export const PaymentLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};